import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

export const Loading = styled.p`
  color: ${(props) => props.theme.colors['secondary-60']};
  font-size: 10px;
  text-align: start;
  display: flex;
  margin-top: 16px;
  align-items: center;
  width: 100%;
  height: 20px;
  svg {
    margin-left: -2px;
    margin-right: 3px;
    animation: ${rotateAnimation} 2s linear infinite;
  }
  &:first-of-type {
    margin-top: 8px;
  }
  &:last-child {
    margin-bottom: 8px;
  }
`;

export const EmptyField = styled.p`
  font-size: 14px;
  opacity: 0;
  margin-left: -5px;
  text-align: start;
  width: 100%;
  svg {
    padding-top: 6px;
    margin-top: -8px;
    float: left;
  }
  display: block;
  padding: 12px 0;
`;
